import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import benHomeImage from './assets/ben-home-portrait.png';

function Home({ user }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        backgroundImage: `url(${benHomeImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '40px 20px',
        backgroundColor: '#000',
      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          padding: '30px 24px',
          borderRadius: '12px',
          color: '#fff',
          maxWidth: '360px',
          width: '100%',
        }}
      >
        <h1 style={{
          fontSize: 'clamp(1.4rem, 5vw, 2.2rem)',
          marginBottom: '6px',
          fontFamily: 'Bangers, sans-serif',
          letterSpacing: '1px',
        }}>
          🤼‍♂️ Welcome{user?.displayName ? `, ${user.displayName.split(' ')[0]}!` : '!'}
        </h1>
        <p style={{
          fontSize: '1rem',
          marginBottom: '4px',
          fontFamily: 'Bangers, sans-serif',
          letterSpacing: '1px',
          color: '#FFD700',
        }}>
          Wrestling Journey 365
        </p>
        <p style={{ fontSize: '0.9rem', marginBottom: '28px', color: '#ccc' }}>
          Get 1% better every day
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button
            onClick={() => navigate('/grind-cards')}
            style={{
              padding: '14px',
              fontSize: '1.1rem',
              backgroundColor: '#2b2b2b',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontFamily: 'Bangers, sans-serif',
              letterSpacing: '1px',
            }}
          >
            🔥 Grind Cards
          </button>

          <button
            onClick={() => navigate('/goals')}
            style={{
              padding: '14px',
              fontSize: '1.1rem',
              backgroundColor: '#2b2b2b',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontFamily: 'Bangers, sans-serif',
              letterSpacing: '1px',
            }}
          >
            🎯 GRIND Goals
          </button>

          <button
            onClick={() => navigate('/fargo')}
            style={{
              padding: '14px',
              fontSize: '1.1rem',
              backgroundColor: '#FFD700',
              color: '#000',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontFamily: 'Bangers, sans-serif',
              letterSpacing: '2px',
              fontWeight: 'bold',
            }}
          >
            🤼 Help Send Ben to Fargo!
          </button>
        </div>

        <p style={{
          marginTop: '20px',
          color: '#555',
          fontSize: '0.8rem',
          fontStyle: 'italic',
        }}>
          Stay on the GRIND
        </p>
      </div>
    </div>
  );
}

export default Home;